if (!customElements.get('dhaga-collection-scroll')) {
  customElements.define('dhaga-collection-scroll', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.collection-grid__wrapper > .grid');
      this.status = this.querySelector('[data-collection-status]');
      this.retry = this.querySelector('[data-collection-retry]');
      if (!this.grid || !this.status || !this.retry) return;
      this.loading = false;
      this.pages = new Set();
      this.retryHandler = event => { event.preventDefault(); this.loadNext(); };
      this.retry.addEventListener('click', this.retryHandler);
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.loadNext();
      }, { rootMargin: '600px 0px' });
      if (this.dataset.nextUrl) this.observer.observe(this.status);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.request?.abort();
      this.retry?.removeEventListener('click', this.retryHandler);
    }

    productKey(card) {
      return card.dataset.productId || card.querySelector('a[href*="/products/"]')?.getAttribute('href')?.split('?')[0];
    }

    async loadNext() {
      if (this.loading || !this.dataset.nextUrl || !this.isConnected) return;
      const url = new URL(this.dataset.nextUrl, window.location.origin);
      if (url.origin !== window.location.origin || this.pages.has(url.href)) return;
      this.loading = true;
      this.retry.hidden = true;
      this.status.textContent = this.dataset.loadingText;
      this.grid.setAttribute('aria-busy', 'true');
      this.observer.unobserve(this.status);
      this.request = new AbortController();
      try {
        const pageUrl = url.href;
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { signal: this.request.signal });
        if (!response.ok) throw new Error('Collection request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = doc.querySelector('dhaga-collection-scroll');
        const nextGrid = next?.querySelector('.collection-grid__wrapper > .grid');
        if (!nextGrid || Number(next.dataset.page) <= Number(this.dataset.page)) throw new Error('Invalid collection page');
        if (!this.isConnected) return;
        const seen = new Set(Array.from(this.grid.children, card => this.productKey(card)).filter(Boolean));
        const cards = Array.from(nextGrid.children).filter(card => {
          const key = this.productKey(card);
          if (key && seen.has(key)) return false;
          if (key) seen.add(key);
          return true;
        });
        if (!cards.length && next.dataset.nextUrl) throw new Error('No new products');
        this.grid.append(...cards);
        this.pages.add(pageUrl);
        this.dataset.page = next.dataset.page;
        this.dataset.nextUrl = next.dataset.nextUrl || '';
        this.retry.href = this.dataset.nextUrl;
        this.status.textContent = this.dataset.nextUrl ? '' : this.dataset.endText;
        if (window.theme?.reinitProductGridItem) window.theme.reinitProductGridItem(this.grid);
      } catch (error) {
        if (error.name === 'AbortError' || !this.isConnected) return;
        this.status.textContent = this.dataset.errorText;
        this.retry.hidden = false;
      } finally {
        this.loading = false;
        this.grid.removeAttribute('aria-busy');
        if (this.isConnected && this.dataset.nextUrl && this.retry.hidden) this.observer.observe(this.status);
      }
    }
  });
}